import { useTranslation } from 'react-i18next';
import { typography } from '@arc/frontend/ui-theme';
export function ToastContent({
  TitleComponent,
  message,
  type
}) {
  const {
    t
  } = useTranslation(['common']);
  return <div data-toast={type}>
			<h1 css={[typography.title, "color:inherit;", message && {
      marginBottom: '0.5rem'
    }, process.env.NODE_ENV === "production" ? "" : ";label:ToastContent;"]}>
				<TitleComponent t={t} />
			</h1>
			<div css={[typography.regular, "color:inherit;white-space:pre-wrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:ToastContent;")]}>
				{message}
			</div>
		</div>;
}